import styled, { css } from "styled-components";

export const Container = styled.div`
  .side-button {
    position: absolute;
    border: none;
    outline: none;
    padding: 0px;
    height: fit-content;
    width: 50px;
    cursor: pointer;
    font-family: inherit;
    font-weight: bold;
    border-radius: 0 0 10px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    -webkit-box-shadow: -4px 3px 6px 3px rgba(0, 0, 0, 0.2);
    -moz-box-shadow: -4px 3px 6px 3px rgba(0, 0, 0, 0.2);
    box-shadow: -4px 3px 6px 3px rgba(0, 0, 0, 0.2);

    span {
      color: #fff;
      margin-top: 6px;
      margin-bottom: 4px;
      margin-right: 3px;
      writing-mode: tb-rl;
      transform: rotate(-180deg);
      font-size: 16px;
    }

    svg {
      height: 30px;
      width: 30px;
      color: #fff;
      transition: 0.5s;
    }
  }

  .toggle-controls {
    height: 180px;
    z-index: 10;
    top: 0px !important;
    left: 0px !important;
    background-color: #41a8bf;

    &:hover {
      svg {
        transform: scale(1.1);
        transform: rotate(20deg);
      }
    }
  }

  .toggle-help {
    height: 220px;
    padding-top: 20px;
    z-index: 5;
    top: 160px !important;
    left: 0px !important;
    background-color: #67ae8b;
  }

  .toggle-history {
    height: 140px;
    padding-top: 5px;
    z-index: 4;
    top: 370px !important;
    left: 0px !important;
    background-color: #e5ab2e;
  }

  @media (max-height: 500px) {
    .side-button span {
      display: none;
    }

    .toggle-controls {
      height: 60px !important;
    }

    .toggle-help {
      top: 50px !important;
      height: 70px !important;
      padding-top: 10px !important;
    }

    .toggle-history {
      top: 110px !important;
      height: 70px !important;
      padding-top: 10px !important;
    }
  }
`;

export const ControlsContainer = styled.div`
  transition: 0.3s ease-in-out;
  z-index: 995;
  position: absolute;
  height: 100vh;
  width: 400px;
  padding: 20px 40px 40px 40px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;

  @media (max-height: 498px) {
    overflow-y: scroll;
  }

  background-color: #f5f6fa;

  button {
    margin-top: 20px;
    border: none;
    outline: none;
    padding: 15px 25px;
    font-size: 16px;
    font-family: inherit;
    font-weight: 500;
    color: #fff;
    background: #41a8bf;
    border-radius: 8px;
    width: 100%;
    cursor: pointer;

    transition: 0.5s;
    &:hover {
      opacity: 0.8;
    }
  }

  .header {
    margin-bottom: 15px;
    display: flex;
    justify-content: space-between;

    img {
      width: 70px;
    }

    .close {
      height: min-content;
      width: 50px;
      margin-left: auto;
      margin-top: 0;
      background: #7771;
      padding: 10px;

      svg {
        color: #777;
        height: 24px;
        width: 24px;
      }
    }
  }

  ${props =>
    props.expanded
      ? css`
          top: 0px !important;
          left: 0px !important;
        `
      : css`
          top: 0px !important;
          left: -400px !important;
        `}

  .size-controller {
    flex-direction: column;
    width: 100%;
    p {
      margin-top: 0px;
      font-size: 16px;
      font-weight: bold;
      color: #718093;
    }
  }

  .range {
    display: flex;
    align-items: center;
    span {
      font-size: 20px;
      font-weight: bold;
      color: #718093;
      width: 50px;
      text-align: end;
    }
  }

  .toggle {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 40px;

    span {
      color: #718093;
      font-family: inherit;
      font-weight: 500;
    }
  }

  .bottom {
    display: flex;
    flex-direction: column;
    margin-top: auto;
    padding-top: 30px;

    .time {
      font-weight: bold;
      color: #555;
    }

    button {
      display: flex;
      align-items: center;
      justify-content: center;
      svg {
        height: 20px;
        width: 20px;
        margin-right: 15px;
      }
    }
  }
`;

export const Backdrop = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  height: 100vh;
  width: 100vw;
  z-index: 1;
`;
